import React, { useEffect, useState } from 'react';
import { Modal } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';

interface ChangelogImagesProps {
    urls: string[];
    alt?: string;
}

function ChangelogImages(props: ChangelogImagesProps) {
    const { urls, alt = '' } = props;
    const { t } = useTranslation();
    const [index, setIndex] = useState<number | null>(null);

    useEffect(() => {
        if (index === null)
            return;

        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape' || e.code === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                setIndex(null);
                return;
            }
            if (urls.length < 2)
                return;
            if (e.key === 'ArrowRight')
                setIndex(i => (i === null ? i : (i + 1) % urls.length));
            if (e.key === 'ArrowLeft')
                setIndex(i => (i === null ? i : (i - 1 + urls.length) % urls.length));
        };

        window.addEventListener('keydown', onKey, true);
        return () => window.removeEventListener('keydown', onKey, true);
    }, [index, urls.length]);

    if (!urls.length)
        return null;

    const step = (delta: number) => {
        setIndex(i => (i === null ? i : (i + delta + urls.length) % urls.length));
    };

    return (
        <>
            <div className="flex flex-wrap gap-2 mt-1 mb-2">
                {urls.map((src, i) => (
                    <button
                        key={src}
                        type="button"
                        className="block max-w-full bg-transparent p-0 border-0 cursor-zoom-in"
                        title={t('projects.enlarge_image') || ''}
                        onClick={() => setIndex(i)}
                    >
                        <img
                            src={src}
                            alt={alt}
                            className="block max-h-80 w-auto max-w-full object-contain rounded border"
                        />
                    </button>
                ))}
            </div>
            <Modal show={index !== null} onClose={() => setIndex(null)} size="7xl" popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="relative flex items-center justify-center min-h-[40vh] px-8">
                        {urls.length > 1 && (
                            <button
                                type="button"
                                className="absolute left-0 p-2 text-gray-400 hover:text-gray-700 dark:text-gray-200"
                                onClick={() => step(-1)}
                            >
                                <Icon type="left" size={8} />
                            </button>
                        )}
                        {index !== null && (
                            <img
                                src={urls[index]}
                                alt={alt}
                                className="max-h-[85vh] w-auto max-w-full object-contain mx-auto"
                            />
                        )}
                        {urls.length > 1 && (
                            <button
                                type="button"
                                className="absolute right-0 p-2 text-gray-400 hover:text-gray-700 dark:text-gray-200"
                                onClick={() => step(1)}
                            >
                                <Icon type="right" size={8} />
                            </button>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ChangelogImages;
